const TOKEN_KEY = 'fleet_token';

export const getToken        = () => localStorage.getItem(TOKEN_KEY);
export const setToken        = (t) => localStorage.setItem(TOKEN_KEY, t);
export const removeToken     = () => localStorage.removeItem(TOKEN_KEY);
export const isAuthenticated = () => {
  const payload = getTokenPayload();
  if (!payload) return false;
  if (payload.exp && Date.now() / 1000 > payload.exp) {
    removeToken();
    return false;
  }
  return true;
};

export const getTokenPayload = () => {
  const token = getToken();
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};

export const getUserRole = () => getTokenPayload()?.role || null;
export const isAdmin     = () => getUserRole() === 'admin';
